const ExternalMainContainer = ({children}: any) => {

    return (
        <div className="external-main-container container-fluid g-0 d-flex bg-surface">
            <main className="overflow-hidden w-100">{children}</main>
        </div>
    )
}

export default ExternalMainContainer